import '@/directives/AscClickOutsideDirective'
import '@/directives/AscElementResizeDetectorDirective'
import Highcharts from '@/maps/Highcharts'
import variables from '@/styles/_varsJs.scss'
import '@mdi/font/css/materialdesignicons.css'
import VueCompositionAPI from '@vue/composition-api'
import axios from 'axios'
import {
  errorInterceptor,
  requestInterceptor,
  responseInterceptor,
} from './utilities/axiosInterceptors'
import 'core-js'
import HighchartsVue from 'highcharts-vue'
import boost from 'highcharts/modules/boost'
import histogramInit from 'highcharts/modules/histogram-bellcurve'
import stockInit from 'highcharts/modules/stock'
import 'pretty-checkbox/src/pretty-checkbox.scss'
import Vue from 'vue'
import VueAppInsights from 'vue-application-insights'
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify/lib'
import { sync } from 'vuex-router-sync'
import App from './App'
import router from './router'
import store from './stores/index'
import VueGtagPlugin from 'vue-gtag'
import { GOOGLE_ANALYTIC_ID } from './utilities/appConsts'
import AscPowerBiIcon from './components/atoms/AscPowerBiIcon'
import AscResourcePermission from './components/mixins/AscResourcePermissionMixin.vue'
import oktaAuth from './plugins/oktaAuth'
import OktaVue from '@okta/okta-vue'

Vue.use(VueCompositionAPI)

Vue.config.productionTip = false
Vue.config.devtools = enableVueTools()
Vue.config.ignoredElements = [...Vue.config.ignoredElements]
Vue.config.errorHandler = function (err, vm, info) {
  const handledAt = 'global error handler - main.js'
  const properties = {
    url: window.location.href,
    stackTrace: err.stack,
    lifeCycleHook: info,
    componentData: JSON.stringify(vm.$data),
  }
  vm.$appInsights.trackException(err, handledAt, properties)
  console.log(err)
  throw err
}

Vue.use(OktaVue, { oktaAuth })

// https://github.com/vuejs/vuex-router-sync
// keeps router synced with store and makes these props available on the store:
// store.state.route.path   // current path (string)
// store.state.route.params // current params (object)
// store.state.route.query  // current query (object)
sync(store, router)

histogramInit(Highcharts)
stockInit(Highcharts)
boost(Highcharts)
Highcharts.setOptions({
  credits: {
    enabled: false,
  },
})

Vue.use(HighchartsVue)

Vue.use(Vuetify)

Vue.use(VueAppInsights, {
  id: getAppInskey(),
  router,
  enableAutoRouteTracking: true,
})

//Configuration Vue gTag
Vue.use(
  VueGtagPlugin,
  {
    config: {
      id: GOOGLE_ANALYTIC_ID,
    },
  },
  router,
)

axios.defaults.baseURL = getApiUrl()
// axios.defaults.withCredentials = true

const reqInterceptor = requestInterceptor(store)
// Setup Axios Response Interceptors
// set up interceptor to log the page name and the URL requested before each request
axios.interceptors.request.use(reqInterceptor)

const respInterceptor = responseInterceptor(store)

const errInterceptor = errorInterceptor.bind(store, router, axios)

axios.interceptors.response.use(respInterceptor, errInterceptor)

Vue.prototype.$http = axios

const vuetifyOptions = {
  icons: {
    iconfont: 'mdi',
    values: {
      powerbi: {
        component: AscPowerBiIcon,
      },
    },
  },
  theme: {
    light: true,
    themes: {
      light: {
        primary: variables.accent400,
        accent: variables.accent400,
        error: variables.warningbase,
      },
    },
  },
}

Vue.mixin(AscResourcePermission)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  vuetify: new Vuetify(vuetifyOptions),
})

function getAppInskey() {
  let key
  if (
    window.location.host.indexOf('localhost') >= 0 ||
    window.location.hostname.indexOf('local.ascentia') >= 0
  ) {
    // TODO do something for local dev?
    key = 'cec2ffcf-b4b4-46f8-b60f-06a2486e2f28'
  } else if (window.location.host.indexOf('dev') >= 0) {
    // all dev slots including QA
    key = 'cec2ffcf-b4b4-46f8-b60f-06a2486e2f28'
  } else if (window.location.host.indexOf('uat') >= 0) {
    key = 'c72dd2e6-daef-4865-a0f1-d3cbd043c8f0'
  } else {
    // staging, prod, custom domains
    key = '312090a1-b720-4b42-9018-fcd3edb39fb8'
  }

  return key
}

function getApiUrl() {
  let apiURL = `${process.env.BASE_URL}/api`
  apiURL = apiURL.replace('//', '/')
  const webHostname = window.location.hostname

  if (
    webHostname.indexOf('localhost') >= 0 ||
    webHostname.indexOf('local.ascentia') >= 0
  ) {
    // Checks for local instance
    apiURL = 'https://localhost:52321'
    // apiURL = 'https://iao-ascentia-api-eastus2-bazalbra.azurewebsites.net'
  }

  return apiURL
}

function enableVueTools() {
  return (
    window.location.host.indexOf('localhost') >= 0 ||
    window.location.hostname.indexOf('local.ascentia') >= 0 ||
    window.location.host.indexOf('dev') >= 0
  )
}
